<cmps-wait-status
    [srStatus]="'Loading ' + config.title"
    *ngIf="hasPendingData"
></cmps-wait-status>
<div *ngIf="!hasPendingData && data == null">
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<ng-container *ngIf="!hasPendingData && data != null">
    <ng-chart-vertical
        [options]="options"
        [data]="data.d3.data"
    ></ng-chart-vertical>
</ng-container>
